var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaxPriceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.00012207,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#DBEFBC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_2501",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 17,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.99988,
    y: 2,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_2501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33321 14V7.86668L6.93321 10.2667L5.99988 9.33334L9.99988 5.33334L13.9999 9.33334L13.0665 10.2667L10.6665 7.86668V14H9.33321Z",
    fill: "#435E19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxPriceIcon);
export default __webpack_public_path__ + "static/media/MaxPriceIcon.a4e3eeadc67deae3231887317b36b47f.svg";
export { ForwardRef as ReactComponent };